
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2815122270/src/vl-app/pages/patients/questions.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
// @ts-check
import React from 'react';
import dynamic from 'next/dynamic';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import { useTranslation } from 'react-i18next';
import Header from '@components/Layouts/Header/Header';

const GeneralQuestions = dynamic(() => import('@components/Clinicians/GeneralQuestions'));

const GeneralHealthQuestions = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="General Health Questions" />
      <section className="section-layout patient" id="page-content">
        <div className="container">
          <div className="title">
            <h1>
              <strong>{t('General Health Questions')}</strong>
            </h1>
            <br />
            <i>{t('Please answer the following questions')}</i>
          </div>
          <GeneralQuestions />
        </div>
      </section>
    </div>
  );
};

export default GeneralHealthQuestions;
export const Route = createFileRoute('/patients/questions')({ component: GeneralHealthQuestions });
